import eSignature from './e-signature.json';
import login from './login.json';
import register from './register.json';
const auth = {
   'e-signature': eSignature,
   login,
   register,
};
export default auth;
